<template>
  <span>
    <span
      v-b-modal="modalId"
      class="badge bg-info badge-1rem expert-hourly-rate"
      role="button"
    >{{ payInfo }}</span>

    <b-modal
      :id="modalId"
      :title="`${expertName}'s hourly rate update`"
      @shown="shownModal"
      @ok="submitRate"
      @hidden="cleanRate"
    >
      <b-form @submit="submitRate">
        <div class="mb-2">
          <label>Expert Hourly Rate</label>
          <b-form-input
            id="input-hourly-rate"
            ref="rateInput"
            v-model="expertRate"
            v-no-wheel
            type="number"
            step="any"
            min="0"
            placeholder="Hourly rate"
            required
          />
        </div>

        <div>
          <label>Hourly Credits to Charge Client:</label>
          <b-form-input
            id="input-credit-client"
            ref="creditInput"
            v-model="clientCredit"
            v-no-wheel
            type="number"
            step="any"
            min="0"
            placeholder="Client credit"
            required
          />
        </div>
      </b-form>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="success"
          @click="ok()"
        ><b-spinner
          v-if="rateUpdating"
          small
          variant="light"
          type="grow"
        /> OK</b-button>
        <b-button
          size="sm"
          variant="danger"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
    name: "HourlyRateUpdate",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            expertRate: null,
            clientCredit: 1,
            rateUpdating: false,
        };
    },
    computed: {
        modalId() {
            return `hourly-update-modal-${this.user.expert.id}`;
        },
        expertName() {
            return this.user.full_name;
        },
        expertPayInfo() {
            const expertPayInfo = this.user.expert?.expert_pay_info;
            if (expertPayInfo === null || expertPayInfo === undefined) {
                return false;
            }

            return expertPayInfo;
        },
        expertHourlyRate: {
            get() {
                return this.getExpertHourlyRate(this.expertPayInfo);
            },
            set(value) {
                this.expertRate = value;
            },
        },
        payInfo() {
            return `$${this.expertHourlyRate}/hr`;
        },
    },
    methods: {
        getExpertHourlyRate(expertPayInfo) {
            return expertPayInfo && (expertPayInfo?.hourly_rate !== undefined && expertPayInfo.hourly_rate !== null) ? expertPayInfo.hourly_rate : "";
        },
        shownModal() {
            this.$refs.rateInput.focus();
            this.expertRate = this.getExpertHourlyRate(this.expertPayInfo);
            this.clientCredit = this.expertPayInfo?.client_credit ?? 1;
        },
        cleanRate() {
            this.expertRate = null;
            this.clientCredit = 1;
        },
        submitRate(e) {
            e.preventDefault();
            this.rateUpdating = true;
            const rateValue = this.expertRate;

            axios.post(
                "/admin/experts/api/pay-info/update-hourly-rate",
                {
                    "expert-id": this.user.expert.id,
                    "hourly-rate": rateValue,
                    "client-credit": this.clientCredit,
                },
            ).then(async response => {
                const updatedRate = response.data.success.rate;

                await this.$store.commit(
                    "expert/updateExpertHourlyRate",
                    {
                        expertId: this.user.expert.id,
                        hourly_rate: updatedRate,
                    });

                await this.$store.commit(
                    "expert/updateExpertClientCredit",
                    {
                        expertId: this.user.expert.id,
                        client_credit: response.data.success.client_credit,
                    });

                One.helpers("jq-notify", {
                    type: "success",
                    icon: "fa fa-check me-1",
                    message: response.data.success.message,
                });
            }).catch(error => {
                One.helpers("jq-notify", {
                    type: "danger",
                    icon: "fa fa-times me-1",
                    message: "There is an error on update hourly rate. Please contact administrator",
                });
            }).finally(() => {
                this.rateUpdating = false;
                this.$bvModal.hide(this.modalId);
            });
        },
    },
};
</script>

<style scoped>

</style>
